export const tr = {
    clicks: 'Toplam tıklama',
    cost: 'Toplam harcama',
    ctr: 'ortalama CTR',
    shows: 'Toplam gösterim'
};
